import {Routes, Route} from "react-router-dom";

// pages 
import Catalog from "../../pages/dashboard/catalog/Catalog";
import CreateCatalog from "../../pages/dashboard/catalog/create/CreateCatalog";
import UpdateCatalog from "../../pages/dashboard/catalog/update/UpdateCatalog";

const CatalogRoutes = () =>{
    return(
        <Routes>
            <Route path="/" element={<Catalog/>} />
            <Route path="/create" element={<CreateCatalog/>} />
            <Route path="/edit/:id" element={<UpdateCatalog/>} />
        </Routes>
    )
}

export default CatalogRoutes